import { createReducer, createAction, createSelector } from "@reduxjs/toolkit";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchSampleFormulations,
  fetchSampleProvenance,
  fetchSampleProcessCSV,
  // fetchSampleProfilometerXYSlices,
  fetchSampleProperties,
} from "../lib/api";

export const actions = {
  request_sample_data: createAction("REQUEST_SAMPLE_DATA"),
  receive_sample_data: createAction("RECEIVE_SAMPLE_DATA"),
  receive_sample_data_failed: createAction("RECEIVE_SAMPLE_DATA_FAILED"),
};

export const constants = {
  NOT_SELECTED: "NOT_SELECTED",
  LOADED: "LOADED",
  LOADING: "LOADING",
  ERROR: "ERROR",
};

export const initState = {
  sample_id: -1,
  loadingState: constants.NOT_SELECTED,
  formulations: [],
  provenance: [],
  eisexperiment: {
    re: [],
    im: [],
  },
  reactorprocessexperiment: {
    force: [],
    distance: [],
  },
  properties: {
    uniformity: "NaN",
    thickness_mean_um: "NaN",
  },
  profilometerXYData: {
    file_present: true,
    horizontal_y: 0,
    vertical_x: 0,
    horizontal_slice: [],
    vertical_slice: [],
  },
};

export const actionMap = {
  [actions.request_sample_data]: (state, action) => {
    state.loadingState = constants.LOADING;

    state.sample_id = action.payload.sample_id;

    return state;
  },
  [actions.receive_sample_data]: (state, action) => {
    state.loadingState = constants.LOADED;

    state.formulations = action.payload.formulations;
    state.provenance = action.payload.provenance;
    state.eisexperiment = action.payload.eisexperiment;
    state.reactorprocessexperiment = action.payload.reactorprocessexperiment;
    state.profilometerXYData = action.payload.profilometerXYData;
    state.properties = action.payload.properties;

    return state;
  },
  [actions.receive_sample_data_failed]: (state) => {
    state.loadingState = constants.ERROR;

    return state;
  },
};

export const reducer = createReducer(initState, actionMap);

const getExperimentSampleData = (state) => state.experimentSampleData;
const getProfilometerXYData = createSelector(
  [getExperimentSampleData],
  (experimentSampleData) => experimentSampleData.profilometerXYData
);
export const selectors = {
  getExperimentSampleData,
  getProfilometerXYData,
};

function* onFetchSampleData(action) {
  try {
    const { sample_id, accessToken } = action.payload;
    const [
      {
        data: { formulations },
      },
      {
        data: { provenance },
      },
      { data: eis },
      { data: reactorprocess },
      {
        data: { properties },
      },
      // { data: profilometerXYData },
    ] = yield all([
      call(fetchSampleFormulations, { accessToken, sample_id }),
      call(fetchSampleProvenance, { accessToken, sample_id }),
      call(fetchSampleProcessCSV, {
        accessToken,
        sample_id,
        process_name: "eis",
      }),
      call(fetchSampleProcessCSV, {
        accessToken,
        sample_id,
        process_name: "reactorprocess",
      }),
      call(fetchSampleProperties, { accessToken, sample_id }),
      // call(fetchSampleProfilometerXYSlices, { accessToken, sample_id }),
    ]);

    if (!Array.isArray(provenance) && provenance !== null) {
      throw Error('missing provenance field from payload')
    }

    yield put(
      actions.receive_sample_data({
        formulations,
        provenance: provenance ?? [],
        eisexperiment: eis,
        reactorprocessexperiment: reactorprocess,
        properties,
        profilometerXYData: {
          file_present: true,
          horizontal_y: 0,
          vertical_x: 0,
          horizontal_slice: [],
          vertical_slice: [],
        },
      })
    );
  } catch (e) {
    console.warn(e);
    yield put(actions.receive_sample_data_failed());
  }
}

export const sagas = {
  watchEveryRequestSampleData: function* watchEveryRequestSampleData() {
    yield takeLatest(actions.request_sample_data.toString(), onFetchSampleData);
  },
};
